import React, { useState } from 'react';

import { Button, ButtonIcon } from '../../../../design-system';
import { ArrowDownSLineIcon } from '../../../../design-system/Icons';
import ScenarioMultiActionPopup from '../ScenarioMultiActionPopup/ScenarioMultiActionPopup';

const ScenarioActionBar = ({
    areChangesToSave,
    isLiveVersionSelected,
    isDefaultVersionSelected,
    handleSaveChanges,
    changeVersionStatus,
    isSaveChangesLoading,
    isStatusChangeLoading,
    isEditable,
}) => {
    const [multiActionPopupOpened, setMultiActionPopupOpened] = useState(false);

    const saveButtonState = !isEditable
        ? 'disabled'
        : isSaveChangesLoading
        ? 'loading'
        : areChangesToSave && !isLiveVersionSelected
        ? 'default'
        : 'disabled';

    const openMultiActionPopupButtonState = !isEditable
        ? 'disabled'
        : isLiveVersionSelected && isDefaultVersionSelected
        ? 'disabled'
        : 'default';

    return (
        <div className="fixed right-4 bottom-3 z-10 p-2 rounded-2">
            <div className="flex gap-[1px] relative">
                <Button
                    type="primary"
                    size="sm"
                    text="Save"
                    state={saveButtonState}
                    noRoundedRight
                    onClick={handleSaveChanges}
                />
                <ButtonIcon
                    type="primary"
                    size="sm"
                    icon={ArrowDownSLineIcon}
                    state={openMultiActionPopupButtonState}
                    noRoundedLeft
                    onClick={() => setMultiActionPopupOpened(true)}
                />

                {multiActionPopupOpened && (
                    <ScenarioMultiActionPopup
                        isLiveVersionSelected={isLiveVersionSelected}
                        isDefaultVersionSelected={isDefaultVersionSelected}
                        changeVersionStatus={changeVersionStatus}
                        handleSaveChanges={handleSaveChanges}
                        isStatusChangeLoading={isStatusChangeLoading}
                        isSaveChangesLoading={isSaveChangesLoading}
                        onClose={() => setMultiActionPopupOpened(false)}
                    />
                )}
            </div>
        </div>
    );
};

export default ScenarioActionBar;
